<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 col-xs-12 left">
        <a href="https://gesthispania.com/" target="_blank">
          <img
            *ngIf="!isDarkTheme"
            class="logo-footer"
            src="https://archivosgeos.s3.eu-west-1.amazonaws.com/Logo_positivo_horizontal.png"
            alt="{{ 'layout.common.logo.gesthispania' | translate }}"
            title="{{ 'layout.common.logo.gesthispania' | translate }}"
            width="130"
          />
          <img
            *ngIf="isDarkTheme"
            class="logo-footer"
            src="https://archivosgeos.s3.eu-west-1.amazonaws.com/Logo_negativo_horizontal.png"
            alt="{{ 'layout.common.logo.gesthispania' | translate }}"
            title="{{ 'layout.common.logo.gesthispania' | translate }}"
            width="130"
          />
        </a>
      </div>
      <div class="col-md-8 col-xs-12">
        <div class="text-md-end footer-links d-sm-block">
          <a href="/faqs">{{ "layout.footer.faq" | translate }}</a>
          <a href="/legal">{{ "layout.footer.legal" | translate }}</a>
          <a href="/privacy">{{ "layout.footer.privacy" | translate }}</a>
          <!-- <a href="/cookies">{{ "layout.footer.cookies" | translate }}</a> -->
        </div>
      </div>
    </div>
  </div>
</footer>
